module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/asset_fiscal.a3ed015d.png";